import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

type StylesType = {
  modal?: boolean
}

const useStyles = makeStyles<Theme, StylesType>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: ({ modal }) => (modal ? '2rem' : '0'),

    [theme.breakpoints.down('md')]: {
      fontSize: theme.size.sm
    }
  },

  title: {
    marginBottom: ({ modal }) => (modal ? '1.5rem' : '1rem'),
    color: '#323436',
    fontSize: theme.size.sm,
    display: 'flex',
    alignItems: 'center'
  },

  inputClass: {
    backgroundColor: '#F5F6F8',

    '&::placeholder': {
      color: '#888888 !important'
    }
  },

  inputRoot: {
    marginBottom: '0.75rem',
    maxWidth: '300px'
  },

  noTags: {
    marginTop: '2px',
    opacity: '0.4'
  },

  tagList: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& > div': {
      marginTop: 2,
      marginBottom: 2
    },

    '& > :not(:last-child)': {
      marginRight: '8px'
    }
  }
}))

export default useStyles
